<template>
  <div class="appointment-detail" :class="{ 'clear-header': isWechatBrowser }">
    <my-header
      v-if="!isWechatBrowser"
      class="top-title"
      title="我的预约"
      :showBack="true"
    ></my-header>
    <div
      style="background: #c4a183;"
      :style="!isWechatBrowser ? 'padding-top:1rem' : ''"
      v-if="appointment.type && appointment.type !== '2'"
    >
      <div class="appointment-type-title">
        {{ appointment.type | appointmentTypeConvert }}预约
      </div>
      <app-progress
        :stages="stages"
        :current="currentStage"
        @changeCurrent="progressClick"
        :selectValue="checkPoint"
      ></app-progress>
    </div>
    <div class="appointment-top">
      <div
        v-if="appointment.type == '2'"
        @click="openPersonDetail(foreman)"
        class="supervisor-info"
      >
        <img class="supervisor-avatar" :src="imgUrl + foreman.avatar" />
        <div class="supervisor-less-info">
          <div class="base-info">
            <div style="padding-top: 0.12rem">
              工长<span class="supervisor-name">{{ foreman.name }}</span>
            </div>
            <div class="score-part">
              <div class="score">{{ foreman.score | serviceScoreConvert }}</div>
            </div>
          </div>
          <div class="supervisor-auth">
            <div class="platform-auth">
              <img src="../../assets/appointment/icon-platform-auth.png" />
              <div>平台认证</div>
            </div>
            <div class="supervisor-deposit">
              <img src="../../assets/appointment/icon-deposit-auth.png" />
              <div>9 万</div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="appointment.type == '1' || appointment.type == '6'"
        @click="openPersonDetail(supervisor)"
        class="supervisor-info"
      >
        <img v-if="supervisor.avatar" class="supervisor-avatar" :src="imgUrl + supervisor.avatar" />
        <img v-else src="../../assets/appointment/icon-supervisor-default-avatar.png" class="supervisor-avatar" />
        <div class="supervisor-less-info">
          <div class="base-info">
            <span style="padding-top: 0.12rem" v-if="appointment.type == '1'"
              >监理</span
            >
            <span style="padding-top: 0.12rem" v-if="appointment.type == '6'"
              >设计师</span
            >
            <span class="supervisor-name">{{ supervisor.name ? supervisor.name : '未分配' }}</span>
            <div class="score-part">
              <div class="score">
                {{ supervisor.score ? supervisor.score : 0 | serviceScoreConvert }}
              </div>
            </div>
          </div>
          <div class="supervisor-auth" style="width: 1.8rem">
            <div class="platform-auth">
              <img src="../../assets/appointment/icon-platform-auth.png" />
              <div>平台认证</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="supervisor-info"
        v-if="appointment.type == '5'"
        style="height: 2.2rem; flex-direction: column"
      >
        <div style="display: flex">
          <img
            class="supervisor-avatar"
            :src="imgUrl + companyInfo.company.logo"
          />

          <div class="supervisor-less-info" style="margin-top: 0.2rem">
            <div class="base-info" style="align-items: center">
              <span style="padding-top: 0.12rem">公司</span>
              <span class="supervisor-name">{{
                companyInfo.company.name
              }}</span>
              <!-- <div class="supervisor-auth" style="width: 1.8rem">
                <div class="platform-auth">
                  <img src="../../assets/appointment/icon-platform-auth.png" />
                  <div>平台认证</div>
                </div>
              </div> -->
            </div>
            <div class="tag-list" @click="openOnestopCompanyDetail(company.id)">
              <div class="tag-item">
                {{ companyInfo.company.constructionGuarantee }}年施工质保
              </div>
              <div class="line"></div>
              <div class="tag-item">
                {{ companyInfo.company.hydropowerGuarantee }}年水电质保
              </div>
              <div class="line"></div>
              <div class="tag-item">
                {{ companyInfo.company.waterproofGuarantee }}年卫生间质保
              </div>
            </div>
          </div>
        </div>
        <div class="management" @click="openOnestopCompanyDetail(company.id)">
          <span class="label">主营：</span
          ><span class="info">{{ companyInfo.company.management }}</span>
        </div>
      </div>
      <div
        v-if="!isGeneralAppointment"
        @click="openPersonDetail(supervisor)"
        class="supervisor-info"
      >
        <img class="supervisor-avatar" :src="imgUrl + supervisor.avatar" />
        <div class="supervisor-less-info">
          <div class="base-info">
            <span style="padding-top: 0.12rem">{{
              supervisor.type | appointmentTypeConvert
            }}</span>
            <span class="supervisor-name">{{ supervisor.name }}</span>
            <div class="score-part">
              <div class="score">
                {{ supervisor.score | serviceScoreConvert }}
              </div>
            </div>
          </div>
          <div class="supervisor-auth" style="width: 1.8rem">
            <div class="platform-auth">
              <img src="../../assets/appointment/icon-platform-auth.png" />
              <div>平台认证</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appointment-title">预约信息</div>
    <div class="appointment-info">
      <div v-if="isGeneralAppointment" class="info-row">
        <div class="info-line">
          <div class="w2">业主</div>
          ：
          <div class="info-content">{{ appointment.name }}</div>
        </div>
        <div v-if="appointment.serviceType != '3'">
          <div class="info-line">
            <div class="w2">户型</div>
            ：
            <div class="info-content">
              {{ appointment.room > 0 ? appointment.room + "室" : "" }}
              {{ appointment.parlour > 0 ? appointment.parlour + "厅" : "" }}
              {{ appointment.toilet > 0 ? appointment.toilet + "卫" : "" }}
              {{ appointment.kitchen > 0 ? appointment.kitchen + "厨" : "" }}
            </div>
          </div>
          <div class="info-line">
            <div class="w2">面积</div>
            ：
            <div class="info-content">{{ appointment.houseArea || 0 }}㎡</div>
          </div>
          <div class="info-line" v-if="areaName">
            <div class="w2">区域</div>
            ：
            <div class="info-content">{{ areaName }}</div>
          </div>
          <div class="info-line" v-if="appointment.village">
            <div class="w2">小区</div>
            ：
            <div class="info-content">{{ appointment.village }}</div>
          </div>
          <div class="info-line">
            <div style="letter-spacing: 0.01rem">房屋类型</div>
            ：
            <div class="info-content">
              {{ appointment.houseType == "1" ? "新房" : "旧房" }}
            </div>
          </div>
          <div class="info-line" v-if="appointment.type == '2'">
            <div style="letter-spacing: 0.01rem">预约订金</div>
            ：
            <div
              class="info-content"
              style="color: #e07070; font-size: 0.34rem"
            >
              {{ appointment.deposit }}元
            </div>
          </div>
        </div>
        <div v-if="appointment.serviceType" class="info-line">
          <div style="letter-spacing: 0.01rem">服务类型：</div>
          <div class="info-content">
            {{ appointment.serviceType | serviceTypeConvert }}
          </div>
        </div>
        <div
          v-if="appointment.serviceType == '3'"
          class="info-line"
          @click="callUp"
        >
          <div style="letter-spacing: 0.01rem">凯哥电话：</div>
          <div class="info-content">{{ servicePhone }}</div>
        </div>
      </div>
      <div v-if="isGeneralAppointment" class="info-row">
        <div class="info-line">
          <div style="letter-spacing: 0.01rem">订单编号：</div>
          <div class="info-content">{{ appointment.orderNo }}</div>
        </div>
        <div class="info-line">
          <div style="letter-spacing: 0.01rem">更新时间：</div>
          <div class="info-content">{{ checkUpdateTime }}</div>
        </div>
        <div class="info-line" v-if="priceRecordList.length == 0">
          <div class="w2">状态</div>
          ：
          <div class="info-content" style="color: #00478e">
            {{ checkAppStatus }}
          </div>
        </div>
        <div class="info-line" v-if="rejectReason">
          <div style="letter-spacing: 0.01rem">驳回原因：</div>
          <div class="info-content" style="color: #e07070">
            {{ rejectReason }}
          </div>
        </div>
        <!-- <div class="info-line" v-if="showActualArea">
          <div style="letter-spacing: 0.01rem">实测面积：</div>
          <div class="info-content">{{ appointment.actualArea || 0 }}㎡</div>
        </div> -->
        <div
          class="info-line"
          v-if="
            (showPrice && appointment.type != '2') ||
              priceRecordList.length == 0
          "
        >
          <div class="w2">报价</div>
          ：
          <div class="info-content" style="color: #e07070">
            {{ !appointment.price ? "未报价" : appointment.price + "元" }}
          </div>
          <div
            class="acceptance-btn"
            v-if="appointment.status == 5"
            @click="acceptDeal()"
          >
            接受报价
          </div>
        </div>
        <!-- <div v-if="showPrice && appointment.type == '2' && priceRecordList.length > 0">
          <div class="info-line">
            <div class="w4">基础施工报价</div>
            ：
            <div class="info-content" style="color: #d54a33">
              {{ priceRecordCurrent.priceBasic + "元" }}
            </div>
          </div>
          <div class="info-line">
            <div class="w4">水电施工报价</div>
            ：
            <div class="info-content" style="color: #d54a33">
              {{ priceRecordCurrent.priceHydropower + "元" }}
            </div>
          </div>
          <div class="info-line">
            <div class="w4">总金额报价</div>
            ：
            <div class="info-content">{{ appointment.price + "元" }}</div>
          </div>
          <div
            class="info-line"
            style="margin-top: 0.3rem"
            v-if="priceRecordCurrent.status == 1"
          >
            <div
              class="acceptance-btn"
              style="margin-left: 0"
              @click="acceptDeal()"
            >
              接受报价
            </div>
            <div
              class="acceptance-btn"
              style="background: #e0dedc; color: #191818"
              @click="rejectDeal()"
            >
              驳回报价
            </div>
          </div>
          <div
            class="info-line"
            style="margin-top: 0.3rem"
            v-if="priceRecordCurrent.status == 3"
          >
            <div class="w4">状态</div>
            ：
            <div class="info-content" style="color: #feac00">已驳回报价</div>
          </div>
        </div> -->
        <div
          class="info-line recommend-appoint-tip"
          v-if="appointment.recommendAppointmentType == '2'"
        >
          此预约为系统免费推荐预约 不收取任何费用
        </div>
      </div>
      <div v-if="!isGeneralAppointment" class="info-row">
        <div class="info-line">
          <div style="letter-spacing: 0.01rem">联系方式：</div>
          <div class="info-content">{{ appointment.phone }}</div>
        </div>
        <div class="info-line">
          <div style="letter-spacing: 0.01rem">更新时间：</div>
          <div class="info-content">{{ checkUpdateTime }}</div>
        </div>
        <div class="info-line">
          <div class="w2">状态</div>
          ：
          <div class="info-content" style="color: #feac00">
            {{ checkAppStatus }}
          </div>
        </div>
        <div class="info-line" v-if="rejectReason">
          <div style="letter-spacing: 0.01rem">驳回原因：</div>
          <div class="info-content">{{ rejectReason }}</div>
        </div>
        <div
          class="info-line recommend-appoint-tip"
          v-if="appointment.recommendAppointmentType == '2'"
        >
          此预约为系统免费推荐预约 不收取任何费用
        </div>
      </div>
    </div>

    <div
      v-if="
        appointment.status != 0 &&
          appointment.status != 8 &&
          appointment.status != 9
      "
      class="footer-btn"
    >
      <div
        class="cancel-btn"
        v-if="appointment.status == 1"
        @click="applyCancel()"
      >
        申请取消
      </div>
      <div
        class="cancel-btn"
        v-if="
          (appointment.status == 2 ||
            appointment.status == 4 ||
            appointment.status == 5 ||
            appointment.status == 6) &&
            isGeneralAppointment &&
            appointment.serviceType != '3'
        "
        @click="applyCancelCheck()"
      >
        申请取消
      </div>
      <div class="canceled-btn" v-if="appointment.status == 7">已取消</div>
    </div>

    <div v-if="priceRecordList.length > 1" class="appointment-title">
      历史报价
    </div>
    <div class="appointment-info" v-if="priceRecordList.length > 1">
      <div
        class="info-row"
        v-for="priceRecord in priceRecordList"
        v-if="priceRecord.status != '1'"
      >
        <div class="info-line">
          <div style="letter-spacing: 0.01rem">更新时间：</div>
          <div class="info-content">
            {{ priceRecord.updateTime | longTime }}
          </div>
        </div>
        <div class="info-line">
          <div>基础施工报价：</div>
          <div class="info-content" style="color: #cecbca">
            {{ priceRecord.priceBasic + "元" }}
          </div>
        </div>
        <div class="info-line">
          <div>水电施工报价</div>
          ：
          <div class="info-content" style="color: #cecbca">
            {{ priceRecord.priceHydropower + "元" }}
          </div>
        </div>
        <div class="info-line">
          <div>总金额报价：</div>
          <div class="info-content" style="color: #cecbca">
            {{ priceRecord.priceBasic + priceRecord.priceHydropower + "元" }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="client-evaluate-form"
      v-if="isShowEvaluateForm"
      style="margin-top: 0.2rem"
    >
      <div class="evaluate-header-title">服务评价</div>
      <div class="evaluate-text">
        <textarea
          rows="5"
          v-model="content"
          placeholder="评价只能修改一次 请您谨慎填写"
        ></textarea>
      </div>
      <div class="footer">
        <div>总体评分</div>
        <div class="evaluate-star">
          <div
            class="star-img"
            v-model="score"
            :class="score <= 0 ? '' : score >= 1 ? 'on' : 'off'"
            @click="selectScore(1)"
          ></div>
          <div
            class="star-img"
            v-model="score"
            :class="score <= 1 ? '' : score >= 2 ? 'on' : 'off'"
            @click="selectScore(2)"
          ></div>
          <div
            class="star-img"
            v-model="score"
            :class="score <= 2 ? '' : score >= 3 ? 'on' : 'off'"
            @click="selectScore(3)"
          ></div>
          <div
            class="star-img"
            v-model="score"
            :class="score <= 3 ? '' : score >= 4 ? 'on' : 'off'"
            @click="selectScore(4)"
          ></div>
          <div
            class="star-img"
            v-model="score"
            :class="score <= 4 ? '' : score >= 5 ? 'on' : 'off'"
            @click="selectScore(5)"
          ></div>
        </div>
      </div>
      <div class="evaluate-btn" @click="insertEvaluate()">提&nbsp;&nbsp;交</div>
      <div class="clear"></div>
      <div v-if="showTip" class="toast general-tip-modal">
        <img
          class="close-btn"
          src="../../assets/icon-close-btn.png"
          @click="closeTip()"
        />
        <div class="general-modal-title border-bottom-style">温馨提示</div>
        <div class="general-modal-msg">
          您还未选择评分<br />请您评分完成再提交评价!
        </div>
        <div class="agree-btn" @click="closeTip()">确定</div>
      </div>
      <div v-if="showTip" class="pay-box"></div>
    </div>
    <div
      class="client-evaluate"
      v-if="customerEvaluateList.length > 0"
      style="margin-top: 0.2rem"
    >
      <div
        class="client-evaluate-item"
        v-for="(evaluate, index) in customerEvaluateList"
        :class="{ 'broder-top': index > 0 }"
      >
        <div class="client-info">
          <img class="client-info-img" :src="evaluate.customerUser.avatarUrl" />
          <div class="client-info-right">
            <div class="cir-name-star">
              <span class="cir-name">{{ evaluate.customerName }}</span>
              <div class="cir-star">
                <div
                  class="star-img"
                  :class="
                    evaluate.score <= 0 ? '' : evaluate.score >= 1 ? 'on' : ''
                  "
                ></div>
                <div
                  class="star-img"
                  :class="
                    evaluate.score <= 1 ? '' : evaluate.score >= 2 ? 'on' : ''
                  "
                ></div>
                <div
                  class="star-img"
                  :class="
                    evaluate.score <= 2 ? '' : evaluate.score >= 3 ? 'on' : ''
                  "
                ></div>
                <div
                  class="star-img"
                  :class="
                    evaluate.score <= 3 ? '' : evaluate.score >= 4 ? 'on' : ''
                  "
                ></div>
                <div
                  class="star-img"
                  :class="
                    evaluate.score <= 4 ? '' : evaluate.score >= 5 ? 'on' : ''
                  "
                ></div>
              </div>
            </div>
            <div class="cir-address-time">
              <span v-if="evaluate.type" class="cir-address"
                >To{{ evaluate.type == "1" ? "监理" : "工长" }} :
                {{ evaluate.to }}</span
              >
              <span v-if="!evaluate.type" class="cir-address"></span>
              <span class="cir-time"
                >{{ evaluate.createTime | time }}
                <img
                  v-if="evaluate.update"
                  @click="toCustomerEvaluateEdit(evaluate.id)"
                  style="width: 0.29rem; height: 0.3rem; margin-left: 0.25rem"
                  src="../../assets/icon/icon-evaluate-edit-btn.png"
              /></span>
            </div>
          </div>
        </div>
        <p class="client-intro">{{ evaluate.content }}</p>
      </div>
    </div>

    <div v-if="cancelAppointmentModal" class="toast general-tip-modal">
      <img
        class="close-btn"
        src="../../assets/icon-close-btn.png"
        @click="cancelApply()"
      />
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">确定要取消该预约吗？</div>
      <div class="agree-btn" @click="confirmCancelAppointment()">确定</div>
    </div>
    <div v-if="cancelAppointmentModal" class="pay-box"></div>

    <div v-if="rejectPriceRecordModal" class="toast general-tip-modal">
      <img
        class="close-btn"
        src="../../assets/icon-close-btn.png"
        @click="cancelReject()"
      />
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">确定要驳回工长报价吗？</div>
      <div class="agree-btn" @click="confirmReject()">确定</div>
    </div>
    <div v-if="rejectPriceRecordModal" class="pay-box"></div>
  </div>
</template>
<script>
import { imgUrl } from "../../config";
import { Toast } from "mint-ui";
import Header from "../../components/header/Header";
import AppointmentProgress from "../../components/AppointmentProgress";
import session from "../../utils/Session";
import DateUtils from "../../utils/DateUtils";
import AppointmentService from "../../service/customer/AppointmentService";
import cancelAppointmentCheckService from "../../service/customer/CancelAppointmentCheckService";
import SupervisorService from "../../service/SupervisorService";
import CompanyService from "../../service/company/CompanyService";
import evaluateService from "../../service/customer/EvaluateService";
import appointmentPriceRecordService from "../../service/customer/AppointmentPriceRecordService";

export default {
  name: "AppointmentDetail",
  components: {
    "my-header": Header,
    "app-progress": AppointmentProgress,
  },
  data() {
    return {
      appointmentId: "",
      appointment: {},
      foreman: {}, //工长（整包的时候使用）
      supervisor: {}, //服务人员（整包的时候作为监理使用）
      imgUrl: imgUrl,
      payConfig: {},
      projectId: {},
      wxPayParams: {},
      serviceRecords: {},
      stages: ["预约", "工长", "量房", "报价", "成功"],
      isWechatBrowser: this.$verfyBrowserType(),
      cancelAppointmentModal: false,
      cancelAppointmentCheckModal: false,
      cancelReason: "",
      newestCancelAppointment: null,
      checkPoint: -1,
      checkStatus: "",
      areaName: "",
      rejectReason: "",
      companyInfo: {},
      isGeneralAppointment: true,
      content: "",
      showTip: false,
      score: "",
      isShowEvaluateForm: false,
      customerEvaluateList: [],
      servicePhone: "17301378008",
      priceRecordList: [],
      priceRecordCurrent: {},
      rejectPriceRecordModal: false,
    };
  },
  beforeMount() {
    document.title = this.$route.meta.title;
    this.appointment.id = this.$route.query.id;
    this.appointmentId = this.$route.query.id;
    this.getAppointmentDetail();
  },
  computed: {
    currentStage() {
      const { status, type } = this.appointment;
      if (parseInt(status) === 1) {
        return 0;
      }
      if (parseInt(status) === 2 && type != "5") {
        return 1;
      }
      if (parseInt(status) === 2 && type == "5") {
        return 1;
      }
      if (parseInt(status) === 3) {
        return 1;
      }
      if (parseInt(status) === 4) {
        return 2;
      }
      if (parseInt(status) === 5 && type == "6") {
        return 3;
      }
      if (parseInt(status) === 5 && type == "2") {
        return 3;
      }
      if (parseInt(status) === 5 && type == "1") {
        return 2;
      }
      if (parseInt(status) === 5 && type == "5") {
        return 3;
      }
      if (parseInt(status) === 6) {
        return 4;
      }
      if (parseInt(status) === 7) {
        return 1;
      }
      if (parseInt(status) === 8) {
        return this.stages.length - 1;
      }
      if (parseInt(status) === 9) {
        return this.stages.length - 1;
      }
    },
    appointmentStatusName() {
      const { status } = this.appointment;
      return this.parseStatusToName(status);
    },
    checkAppStatus() {
      let status = this.parseStageToStatus(this.checkPoint);
      return this.parseStatusToName(status);
    },
    checkUpdateTime() {
      let status = this.parseStageToStatus(this.checkPoint);
      let serviceRecord = this.serviceRecords[status];
      if (serviceRecord) {
        if (serviceRecord.opinion) {
          this.rejectReason = serviceRecord.opinion;
        } else {
          this.rejectReason = "";
        }
        let time =
          this.serviceRecords[status].createTime || this.appointment.updateTime;
        return DateUtils.parseLongTimeToDate(time);
      } else {
        return DateUtils.parseLongTimeToDate(this.appointment.updateTime);
      }
    },
    showActualArea() {
      let { status: appointmentStatus, type } = this.appointment;
      let checkStatus = this.checkStatus;
      return appointmentStatus >= 4 && checkStatus >= 4 && type == "2";
    },
    showPrice() {
      let { status: appointmentStatus, type } = this.appointment;
      if (type != "1") {
        let checkStatus = this.checkStatus;
        return parseInt(appointmentStatus) >= 5 && parseInt(checkStatus) >= 5;
      } else {
        return false;
      }
    },
  },
  methods: {
    toCustomerEvaluateEdit(id) {
      this.$router.push({ name: "CustomerEvaluateEdit", query: { id } });
    },
    selectScore(score) {
      this.score = score;
    },
    closeTip() {
      this.showTip = false;
    },
    callUp() {
      window.location.href = "tel:" + this.servicePhone;
    },
    async getAppointmentEvaluate() {
      var result = await evaluateService.evaluateList(
        this.appointment.supervisorId,
        "",
        ""
      );
      if (result.code == 0) {
        this.customerEvaluateList = result.data;
        for (let evaluate of this.customerEvaluateList) {
          if (!evaluate.customerName) {
            evaluate.customerName = evaluate.customerUser.nickname;
          }
        }
        if (result.data.length == 0 && this.appointment.status == "2") {
          this.isShowEvaluateForm = true;
        }
      } else {
        Toast("获取评价信息失败");
      }
    },
    async insertEvaluate() {
      if (this.score == 0) {
        this.showTip = true;
        return;
      }
      var result = await evaluateService.evaluatePost(
        this.appointment.supervisorId,
        "",
        this.score,
        this.content
      );
      if (result.code == "0") {
        this.getAppointmentDetail();
        this.isShowEvaluateForm = false;
        Toast("提交成功！");
      } else {
        Toast("评价未成功，请稍后重试！");
      }
    },
    progressClick(index) {
      this.checkPoint = index > this.currentStage ? this.currentStage : index;
      this.checkStatus = this.parseStageToStatus(this.checkPoint);
    },
    parseStageToStatus(stage) {
      const { type, status } = this.appointment;
      const currentStage = this.currentStage;
      if (stage >= currentStage) {
        return status;
      }
      let statusList = [];
      if (status == "7") {
        statusList = ["1", "7"];
      } else {
        if (type === "1" || type === "3" || type === "4" || type === "8") {
          statusList = ["1", "2", status];
        } else if (type === "2") {
          statusList = ["1", "2", "4", "5", status];
        } else if (type === "5") {
          statusList = ["1", "2", "4", "6", status];
        } else if (type === "6") {
          statusList = ["1", "2", "4", "5", status];
        }
      }
      return statusList[stage] || status;
    },
    parseStatusToName(status) {
      let { type } = this.appointment;
      if (status === "1") {
        return "确认";
      }
      if (
        status === "2" &&
        type !== "1" &&
        type !== "3" &&
        type !== "4" &&
        type !== "8"
      ) {
        return "确认";
      }
      if (status === "2" && type === "5") {
        return "确认";
      }
      if (
        status === "2" &&
        (type === "1" || type === "3" || type === "4" || type === "8")
      ) {
        return "确认";
      }
      if (status === "3") {
        return "驳回";
      }
      if (status === "4") {
        return "报价";
      }
      if (status === "5") {
        return "等待接受报价";
      }
      if (status === "6") {
        return "签约";
      }
      if (status === "7") {
        return "取消";
      }
      if (status === "8") {
        return "成功";
      }
      if (status === "9") {
        return "成功";
      }
    },
    async getAppointmentDetail() {
      var result = await AppointmentService.getAppointmentDetail(
        this.appointment.id
      );
      console.log(result, "输出result");
      if (result.code == "0") {
        this.appointment = result.data;
        if (
          this.appointment.type == 3 ||
          this.appointment.type == 4 ||
          this.appointment.type == 8
        ) {
          this.isGeneralAppointment = false;
          this.getAppointmentEvaluate();
        }
        if (this.appointment.type == 2) {
          this.getPriceRecord(this.appointmentId);
        }
        this.areaName = this.appointment.areaName || "";
        this.checkStatus = this.appointment.status;
        const { type, status } = result.data;
        if (status == "7") {
          this.stages = ["预约", "取消"];
        } else {
          if (type === "1" || type === "3" || type === "4" || type === "8") {
            this.stages = ["预约", "成功"];
          } else if (type === "2") {
            this.stages = ["预约", "确认", "量房", "报价", "成功"];
          } else if (type === "5") {
            this.stages = ["预约", "确认", "量房", "报价", "成功"];
          } else if (type === "6") {
            this.stages = ["预约", "确认", "量房", "报价", "成功"];
          }
        }
        if (this.appointment.status != "1") {
          this.loadNewestCancelAppointment();
        }
        const id = result.data.id;
        if (id) {
          this.getServiceRecord(id);
        }
        this.projectId = result.data.projectId;
        if (this.appointment.supervisorId != null) {
          this.getSupervisorInfo(this.appointment.supervisorId);
        }
        if (this.appointment.foremanId != null) {
          this.getForemanInfo(this.appointment.foremanId);
        }
        if (this.appointment.type == "5") {
          this.getCompanyInfo(this.appointment.companyId);
        }
      } else {
        Toast("获取预约详情失败");
      }
    },
    async getPriceRecord(id) {
      let { code, data } = await appointmentPriceRecordService.history(id);
      console.info("da", data);
      console.info("da", code);
      if (code == 0) {
        if (data.length > 0) {
          this.priceRecordList = data;
          this.priceRecordCurrent = this.priceRecordList[0];
        }
      } else {
        Toast("获取工长报价记录信息失败");
      }
    },
    async rejectDeal() {
      this.rejectPriceRecordModal = true;
    },
    cancelReject() {
      this.rejectPriceRecordModal = false;
    },
    async confirmReject() {
      console.info(this.appointmentId);
      var result = await appointmentPriceRecordService.reject(
        this.priceRecordCurrent.id
      );
      if (result.code == "0") {
        this.getPriceRecord(this.appointmentId);
        this.rejectPriceRecordModal = false;
        Toast("驳回报价成功");
      } else {
        Toast("驳回报价失败");
      }
    },
    async getCompanyInfo(id) {
      let { code, data: companyInfo } = await CompanyService.getCompanyInfo(id);
      if (code == 0) {
        this.companyInfo = companyInfo;
      } else {
        Toast("获取整包公司信息失败");
      }
    },
    async getServiceRecord(id) {
      var result = await AppointmentService.getServiceRecords(id);
      if (result.code == 0) {
        this.serviceRecords = result.data;
      } else {
        Toast("获取服务记录失败");
      }
    },
    async getForemanInfo(id) {
      var result = await SupervisorService.getSupervisorDetail(id);
      if (result.code == 0) {
        this.foreman = result.data;
      } else {
        Toast("获取工长详情失败");
      }
    },
    async getSupervisorInfo(id) {
      var result = await SupervisorService.getSupervisorDetail(id);
      if (result.code == 0) {
        this.supervisor = result.data;
      } else {
        Toast("获取监理详情失败");
      }
    },
    openPersonDetail(supervisor) {
      let supervisorId = supervisor.id;
      if (supervisor.type == "1") {
        this.$router.push({
          name: "SupervisorDetail",
          query: { supervisorId },
        });
      } else if (supervisor.type == "2") {
        this.$router.push({
          name: "GangmasterDetail",
          query: { supervisorId },
        });
      } else if (supervisor.type == "5") {
        this.$router.push({ name: "DesignerDetail", query: { supervisorId } });
      } else if (supervisor.type == "3") {
        if (!!this.global.isMiniProgrm) {
          wx.miniProgram.navigateTo({
            url: `/pages/housekeeping/detail/index?serviceId=${supervisorId}&serviceType=${
              supervisor.type
            }`,
          });
        } else {
          this.$router.push({ name: "CleanerDetail", query: { supervisorId } });
        }
      } else if (supervisor.type == "4") {
        if (!!this.global.isMiniProgrm) {
          wx.miniProgram.navigateTo({
            url: `/pages/housekeeping/detail/index?serviceId=${supervisorId}&serviceType=${supervisor.type}`,
          });
        } else {
          this.$router.push({ name: "MoverDetail", query: { supervisorId } });
        }
      } else if (supervisor.type == "8") {
        if (!!this.global.isMiniProgrm) {
          wx.miniProgram.navigateTo({
            url: `/pages/housekeeping/detail/index?serviceId=${supervisorId}&serviceType=${supervisor.type}`,
          });
        } else {
          this.$router.push({ name: "PuncherDetail", query: { supervisorId } });
        }
      }
    },
    async acceptDeal() {
      var result = {};
      if (this.appointment.type == "2") {
        result = await AppointmentService.acceptDeal(
          this.appointmentId,
          this.priceRecordCurrent.id
        );
      } else {
        result = await AppointmentService.acceptDeal(this.appointmentId);
      }
      if (result.code == "0") {
        this.appointment = result.data;
        this.appointment.status == 6;
        this.appointment.tradeSettlementStatus == "1";
        this.getServiceRecord(this.appointment.id);
        if (this.appointment.type == 2) {
          this.getPriceRecord(this.appointmentId);
        }
        Toast("接受报价成功");
      } else {
        Toast("接受报价失败");
      }
    },
    applyCancel() {
      this.cancelAppointmentModal = true;
    },
    async confirmCancelAppointment() {
      let { code, msg, data } = await AppointmentService.cancelAppointment(
        this.appointment.id
      );
      if (code == "0") {
        this.cancelAppointmentModal = false;
        Toast("取消预约成功!");
        this.getAppointmentDetail();
      } else {
        Toast("取消预约失败!");
      }
    },
    cancelApply() {
      this.cancelAppointmentModal = false;
    },
    async applyCancelCheck() {
      let result = await AppointmentService.getAppointmentDetail(
        this.appointment.id
      );
      if (result.code == "0") {
        if (result.data.status == 9) {
          this.getAppointmentDetail();
          Toast("该预约已生成项目!无法申请取消预约!");
        } else {
          this.cancelAppointmentModal = true;
        }
      }
    },
    async loadNewestCancelAppointment() {
      let result = await cancelAppointmentCheckService.getNewestCancelAppointment(
        this.appointment.id,
        session.getAccountToken().id
      );
      if (result.code == "0") {
        if (result.data) {
          this.newestCancelAppointment = result.data;
        }
      } else {
        Toast("获取取消预约审核结果失败!");
      }
    },
    toOnestopCompany(companyId) {
      this.$router.push({ name: "OnestopCompany", query: { companyId } });
    },
  },
};
</script>

<style lang="scss">
.clear-header {
  margin-top: -1rem;
}
.client-evaluate {
  background-color: white;
  padding-bottom: 0.2rem;
  padding-left: 0.28rem;
  .client-evaluate-item {
    padding-top: 0.4rem;
    padding-right: 0.28rem;
    .client-info {
      display: flex;
      .client-info-img {
        width: 0.89rem;
        height: 0.89rem;
        border-radius: 1rem;
        background-color: #999;
      }
      .client-info-right {
        flex-grow: 1;
        padding-left: 0.3rem;
        .cir-name-star {
          font-size: 0.32rem;
          color: #1b1e29;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .cir-star {
            display: flex;
            justify-content: flex-end;

            .star-img {
              width: 0.32rem;
              height: 0.3rem;
              margin-left: 0.1rem;
              background-image: url("../../assets/icon/icon-star-off.png");
              background-size: 100%;
            }
            .on {
              background-image: url("../../assets/icon/icon-star-on.png");
            }
            .off {
              background-image: url("../../assets/icon/icon-star-off.png");
            }
          }
        }
        .cir-address-time {
          margin-top: 0.1rem;
          color: #878e99;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .client-intro {
      text-align: left;
      margin-top: 0.2rem;
      margin-bottom: 0.38rem;
      color: #878e99;
      line-height: 0.39rem;
    }
  }
  .broder-top {
    border-top: solid 0.02rem #dae2e5;
  }
}
.appointment-detail {
  padding-bottom: 0.3rem;
  color: #999999;
  background: white;
  font-size: 0.25rem;
  .recommend-appoint-tip {
    margin-top: 0.4rem;
    padding-top: 0.3rem;
    font-size: 0.32rem;
    color: #d54a33;
    border-top: 1px solid #eee;
  }
  .border-bottom-style {
    border-bottom: solid 1px #eee;
  }
  .appointment-type-title {
    padding-top: 0.37rem;
    padding-left: 0.34rem;
    font-size: 0.42rem;
    color: white;
    font-weight: bold;
  }
  .appointment-top {
    .supervisor-info {
      display: flex;
      width: 6.8rem;
      height: 1.9rem;
      margin: 0.3rem auto 0;
      background-color: #f8f8f8;
      border-radius: 0.1px;
      .management {
        margin-top: 0.1rem;
        font-size: 0.3rem;
        margin-left: 0.2rem;

        .label {
          color: #999999;
        }
      }
      .supervisor-avatar {
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.1rem;
        margin: 0.3rem 0.3rem 0;
      }
      .supervisor-less-info {
        margin-top: 0.4rem;
        .base-info {
          display: flex;
        }
        .supervisor-name {
          margin-left: 0.2rem;
          font-size: 0.36rem;
          color: #191818;
        }
        .supervisor-auth {
          display: flex;
          width: 3.24rem;
          height: 0.4rem;
          line-height: 0.45rem;
          border-radius: 0.04rem;
          margin-top: 0.19rem;
          background: #e8eff7;
          font-size: 0.26rem;
          color: #00478e;
          img {
            width: 0.27rem;
            height: 0.28rem;
            margin-top: 0.06rem;
            margin-right: 0.1rem;
          }
          .platform-auth {
            display: flex;
            padding-left: 0.23rem;
          }
          .supervisor-deposit {
            display: flex;
            padding-left: 0.29rem;
          }
        }
        .tag-list {
          width: 4.5rem;
          height: 0.6rem;
          line-height: 0.6rem;
          margin-top: 0.2rem;
          padding: 0rem 0.1rem;
          display: flex;
          justify-content: space-between;
          background-color: #efebe5;
          border-radius: 0.1rem;
          color: #9d704a;
          font-size: 0.22rem;
          .tag-item {
            white-space: nowrap;
          }
          .line {
            width: 1px;
            height: 0.24rem;
            margin-top: 0.2rem;
            background-color: #9d704a;
          }
        }
      }

      .score-part {
        margin-top: 0.07rem;
        margin-left: 0.25rem;
        background-image: url(../../assets/icon-score-bg.png);
        background-size: 0.8rem 0.33rem;
        background-repeat: no-repeat;
        .score {
          width: 0.74rem;
          height: 0.3rem;
          margin-left: 0.35rem;
          color: #e07070;
          font-size: 0.25rem;
          font-weight: bold;
        }
      }
    }
  }
  .company-item {
    margin: 0 auto 0.3rem;
    padding: 0.5rem 0.4rem 0.48rem 0.2rem;
    background: #f7f6f2;
    font-size: 0.3rem;
    color: #333;
    .top {
      display: flex;
    }
    img {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 1.3rem;
    }
  }
  .base-info {
    width: 5.4rem;
    .top {
      margin-top: 0.14rem;
      margin-left: 0.3rem;
      font-size: 0.34rem;
      color: #333;
      font-weight: bold;
    }
    .platform {
      margin-top: -5px;
      margin-left: 8px;
      width: 80px;
      height: 33px;
      border-radius: 0;
    }

    .label {
      font-size: 0.28rem;
      color: #7f7d7c;
    }
  }
  .appointment-title {
    padding: 0.3rem 0.35rem;
    font-size: 0.34rem;
    font-weight: bold;
    color: #333;
  }
  .appointment-info {
    width: 6.8rem;
    font-size: 0.33rem;
    margin: 0 auto;
    line-height: 0.45rem;
    border-radius: 0.1rem;
    border: solid 1px #eee;
    .info-row {
      width: 6.3rem;
      margin: 0 auto;
      padding-top: 0.27rem;
      padding-bottom: 0.4rem;
      border-bottom: 1px solid #e0dedc;
      &:last-child {
        padding-top: 0.4rem;
        padding-bottom: 0.79rem;
        border-bottom: none;
      }
      .info-line {
        display: flex;
        flex-flow: row nowrap;
        justify-content: start;
        align-items: center;
        .info-content {
          flex-shrink: 0;
          color: #191818;
        }
        .acceptance-btn {
          width: 1.42rem;
          height: 0.4rem;
          margin-left: 0.35rem;
          line-height: 0.42rem;
          text-align: center;
          background-color: #ffeecc;
          border-radius: 0.4rem;
          font-size: 0.2rem;
          color: #feac00;
        }
      }
    }
  }
  .client-evaluate-form {
    width: 6.9rem;
    margin: 0 auto;
    padding: 0 0.28rem;
    background-color: white;
    .evaluate-header-title {
      height: 0.78rem;
      display: flex;
      font-size: 0.36rem;
      align-items: center;
      color: #191818;
      font-weight: bold;
    }
    .evaluate-text {
      width: 100%;
      textarea {
        width: calc(100% - 0.57rem);
        height: 1.77rem;
        color: #1b1e29;
        line-height: 0.42rem;
        background-color: #f7f6f5;
        padding: 0.23rem 0.23rem 0.23rem 0.34rem;
        resize: none;
        outline: none;
        font-size: 0.32rem;
        ::placeholder {
          color: #cecbca;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: space-between;
    }
    .evaluate-star {
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .star-img {
      width: 0.32rem;
      height: 0.3rem;
      margin-left: 0.1rem;
      background-image: url("../../assets/icon/icon-star-off.png");
      background-size: 100%;
    }
    .on {
      background-image: url("../../assets/icon/icon-star-on.png");
    }
    .off {
      background-image: url("../../assets/icon/icon-star-off.png");
    }
    .evaluate-btn {
      float: right;
      width: 1.68rem;
      height: 0.6rem;
      margin-top: 0.4rem;
      margin-bottom: 1.17rem;
      background-color: #feac00;
      text-align: center;
      line-height: 0.6rem;
      border-radius: 1rem;
      color: white;
      font-size: 0.32rem;
    }
  }
  .footer-btn {
    display: flex;
    justify-content: flex-end;
    width: 6.9rem;
    margin: 0.46rem auto;
  }
  .cancel-btn {
    width: 1.9rem;
    height: 0.6rem;
    line-height: 0.63rem;
    background-color: #00478e;
    text-align: center;
    border-radius: 0.1rem;
    font-size: 0.32rem;
    color: white;
  }
  .general-tip-modal {
    width: 100%;
    height: 7rem;
    background-color: white;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
    font-size: 0.32rem;
    color: #7f7d7c;
    z-index: 1002;
    .close-btn {
      position: absolute;
      width: 0.29rem;
      right: 0.3rem;
      top: 0.5rem;
    }
    .general-modal-title {
      width: 6.9rem;
      margin: 0 auto;
      line-height: 1.18rem;
      font-size: 0.36rem;
      color: #191818;
      font-weight: bold;
    }
    .general-modal-msg {
      padding-top: 0.85rem;
    }
    .agree-btn {
      width: 1.9rem;
      height: 0.7rem;
      margin: 2.18rem auto 0;
      line-height: 0.72rem;
      color: white;
      background-color: #feac00;
      border-radius: 0.7rem;
    }
  }
  .canceled-btn {
    width: 1.69rem;
    height: 0.61rem;
    background: #cecbca;
    border-radius: 0.1rem;
    font-size: 0.28rem;
    color: #7f7d7c;
    text-align: center;
    margin-right: 0.3rem;
    margin-left: 0.3rem;
    line-height: 0.61rem;
    margin-bottom: 0.36rem;
  }
  .toast {
    background-color: white;
    position: fixed;
    z-index: 900;
    text-align: center;
    bottom: 0;
    left: 0;
  }
  .pay-box {
    overflow: hidden;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
  }
  .w2 {
    letter-spacing: 2em;
    margin-right: -2em;
    padding-right: 0.02rem;
  }
  a {
    text-decoration: none;
  }
}
</style>
